import {
	Text,
	Button,
	HStack,
	VStack,
} from '@montel/montelpro-shared-components-v2';
import { Company } from 'domain/company/Company';
import { MatchType } from 'components/companies/AssignToCompanyForm/useSuggestedCompanies';
import SectionDivider from 'components/common/SectionDivider';
import { useAssignToCompanyFormContext } from 'components/companies/AssignToCompanyForm/AssignToCompanyFormContext';

export const SuggestedCompanies: React.FC<{
	selectCompany: (company: Company) => void;
}> = ({ selectCompany }) => {
	const { suggestions, selectedCompany } = useAssignToCompanyFormContext();
	const mostRelevantSuggestions = suggestions.companies.slice(0, 10);

	return (
		<VStack gap="md" fullWidth align="center">
			{suggestions.companies.length > 0 && (
				<SectionDivider size="sm" fullWidth />
			)}
			<SuggestedCompaniesText matchedOn={suggestions.matchedOn} />
			{suggestions.companies.length > 0 && (
				<HStack fullWidth wrap="wrap" gap="xs" justify="center">
					{mostRelevantSuggestions.map((company) => (
						<SuggestedCompany
							key={company.id}
							company={company}
							selectCompany={selectCompany}
							selectedCompany={selectedCompany}
						/>
					))}
				</HStack>
			)}
		</VStack>
	);
};

const SuggestedCompany: React.FC<{
	company: Company;
	selectCompany: (company: Company) => void;
	selectedCompany?: Company;
}> = ({ company, selectCompany, selectedCompany }) => (
	<Button
		variant={company.id == selectedCompany?.id ? 'primary' : 'secondary'}
		size="md"
		text={
			company.youniumAccountNumber
				? `${company.name} (${company.youniumAccountNumber})`
				: company.name
		}
		onClick={() => selectCompany(company)}
	/>
);

export const SuggestedCompaniesText: React.FC<{
	matchedOn?: MatchType;
}> = ({ matchedOn }) => {
	switch (matchedOn) {
		case MatchType.TokenMatch:
			return (
				<Text>
					These companies partially match the users&apos; company name
				</Text>
			);
		case MatchType.DomainMatch:
			return (
				<Text>These companies match the users&apos; email domain</Text>
			);
		case MatchType.NameMatch:
			return (
				<Text>These companies match the users&apos; company name</Text>
			);
		case MatchType.NoMatch:
		default:
			return (
				<Text fontStyle="italic" size="xs" color="textSubtle">
					No company suggestions could be found
				</Text>
			);
	}
};
